import { updateOnboardingProfileApi as generatedUpdateOnboardingProfileApi } from '../generated/onboarding/updateOnboardingProfile';

import { getOnboardProfileDraftApi } from './getOnboardProfileDraft';

const updateOnboardingProfileApi = generatedUpdateOnboardingProfileApi.enhanceEndpoints({
  endpoints: {
    updateOnboardingProfile: {
      invalidatesTags: ['Onboard'],
      onQueryStarted: async ({ body }, { dispatch, queryFulfilled }) => {
        const patchResult = dispatch(
          getOnboardProfileDraftApi.util.updateQueryData('getOnboardProfileDraft', undefined, (draft) => {
            draft.profile = {
              ...draft.profile,
              ...body,
            };

            if (draft.progress != null) {
              draft.progress.profile = true;
            } else {
              draft.progress = { profile: true };
            }
          }),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    },
  },
});

export const { useUpdateOnboardingProfileMutation } = updateOnboardingProfileApi;
